import getters from '@/store/modules/cart/getters'

getters.getLoyaltyThresholds = (state) => {
  let loyaltyThresholds = state.loyaltyThresholds
  if (loyaltyThresholds && Object.keys(loyaltyThresholds).length) {
    return loyaltyThresholds
  } else {
    return false
  }
}

getters.getCustomerLoyalty = (state) => {
  let customerLoyalty = state.customer_loyalty
  if (customerLoyalty && Object.keys(customerLoyalty).length) {
    return customerLoyalty
  } else {
    return false
  }
}

getters.getLoyaltyRewards = (state) => {
  let rewards = state.rewards
  if (rewards && Object.keys(rewards).length) {
    return rewards
  } else {
    return []
  }
}

getters.getActiveLoyalty = (state) => {
  if (state.total && state.total.extension_attributes) {
    return state.total.extension_attributes.loyalty
  } else {
    return ''
  }
}

getters.getPricesAdjustments = (state) => {
  if (state.total && state.total.extension_attributes) {
    let prAdj = state.total.extension_attributes.price_adjustements
    // for (const key in prAdj) {
    //   if (prAdj[key] && prAdj[key].length) {
    //     prAdj[key] = prAdj[key].filter(pr => pr.custom && pr.manual)
    //   }
    // }
    return prAdj
  } else {
    return {}
  }
}

getters.hasPricesAdjustments = (state, getters) => {
  let prj = getters['getPricesAdjustments']
  let hasPrices = false
  if (prj && Object.values(prj).length) {
    let prjArrs = Object.values(prj)
    for (let index = 0; index < prjArrs.length; index++) {
      if (prjArrs[index].length) {
        hasPrices = true
        break
      }
    }
  }
  return hasPrices
}

getters.getProductPriceAdj = (state, getters) => {
  let { products } = { ...getters['getPricesAdjustments'] }
  return products
}

getters.stockOnCart = (state, getters) => (sku) => {
  if (sku) {
    let isInCart = getters['items'].find((item) => item.extension_attributes.sku === sku)
    return isInCart && isInCart.qty ? isInCart.qty : 0
  } else {
    return 0
  }
}

getters.getGiftCards = (state) => {
  return state.giftcards
}

getters.getAppliedCoupons = (state) => {
  if (state.total && state.total.extension_attributes) {
    return state.total.extension_attributes.coupons
  } else {
    return []
  }
}

getters.getActiveGiftCards = (state, _, rootState) => {
  if (state.activeGiftcards && state.activeGiftcards.length) {
    return state.activeGiftcards
  } else {
    let giftcards = []
    try {
      giftcards = state.total.extension_attributes.giftcards
    } catch (err) {
      giftcards = []
    }
    return giftcards
  }
}

// get items totals
getters.cartItemsTotal = (state) => {
  if (state.total && 'items_total' in state.total.extension_attributes) {
    return state.total.extension_attributes.items_total
  } else {
    return state.items.reduce((sum, item) => sum + item.row_total_incl_tax)
  }
}

// get shipping price
getters.getShippingAmount = (state) => {
  if (state.total && 'shipping_incl_tax' in state.total) {
    return state.total.shipping_incl_tax
  } else {
    return undefined
  }
}

export default {
  ...getters
}
